import { gridSizeMdLg12, gridSizeMdLg6 } from "@/shared";
import { CustomTextField } from "@/shared/components/ui";
import { Grid, Typography } from "@mui/material";
import { useGastos } from "@/store/erp/gastos/useGastos";

import { Gastos } from "@/shared/interfaces/erp/inventario";
import { useEffect } from "react";
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import { useFormContext, useWatch } from "react-hook-form";

type ValoresFacturaProps = {
  optionTipoFactura: number
}
export default function ValoresFactura({ optionTipoFactura }: ValoresFacturaProps) {
  const { control, setValue, getValues, formState: { errors } } = useFormContext()
  //store_gasto
  const gastos = useGastos(s => s.gastos) as Gastos[]
  const totalIVA = gastos.reduce((acc, item: Gastos) => acc + Number(item.valor_iva || 0), 0)
  const totalSubtotalSinIva = gastos.reduce((acc, item: Gastos) => acc + Number(item.subtotal_sin_iva || 0), 0)
  const totalGeneral = gastos.reduce((acc, item) => acc + Number(item.total || 0), 0)
  ///store_producto
  const productos = useCargarSeriesProductos(s => s.productos)
  const prodTotaIVA = productos.reduce((acc, item) => acc + Number(item.iva_producto || 0), 0)
  const prodSubTotalSinIva = productos.reduce((acc, item) => acc + Number(item.subtotal_descuento || 0), 0)
  const prodDescuento = productos.reduce((acc, item) => acc + Number(item.descuento || 0), 0)
  const prodTotalGeneral = productos.reduce((acc, item) => acc + Number(item.total_producto || 0), 0)
  //Escuchar cambios de iva_otro y valor_otro
  const subtotolsinIva_otro = useWatch({ control, name: "costo_otro" })
  const iva_otro = useWatch({ control, name: "iva_otro" })
  const total_otro = useWatch({ control, name: "total_otro" })

  //Hook
  /* const {
    form, errors, reset
  } = useRegistroFacturas() */
  ///ORDEN_COMPRA
  useEffect(() => {
    if (productos.length > 0 && optionTipoFactura === 0) {

      const costoOtroNum = Number(subtotolsinIva_otro || 0)
      const ivaOtroNum = Number(iva_otro || 0)
      const totalOtroNum = Number(total_otro || 0)

      //suma al total de productos
      setValue("subtotal_sin_iva", (prodSubTotalSinIva + costoOtroNum).toFixed(2))
      setValue("iva", (prodTotaIVA + ivaOtroNum).toFixed(2))
      setValue("descuento", prodDescuento.toFixed(2))
      setValue("total_compra", (prodTotalGeneral + totalOtroNum).toFixed(2))
    } else {
      setValue("subtotal_sin_iva", "")
      setValue("iva", "")
      setValue("descuento", "")
      setValue("total_compra", "")
    }
  }, [prodSubTotalSinIva, prodTotalGeneral, prodTotaIVA, prodTotalGeneral, subtotolsinIva_otro, iva_otro, total_otro])

  //GASTO
  useEffect(() => {
    if (gastos.length > 0 && optionTipoFactura === 1) {
      setValue("subtotal_sin_iva", totalSubtotalSinIva.toFixed(2))
      setValue("iva", totalIVA.toFixed(2))
      setValue("total_compra", totalGeneral.toFixed(2))
    } else {
      setValue("subtotal_sin_iva", "")
      setValue("iva", "")
      setValue("descuento", "")
      setValue("total_compra", "")
    }
  }, [totalSubtotalSinIva, totalIVA, totalGeneral, optionTipoFactura])

  //COMBINADO
  useEffect(() => {

    if ((gastos.length > 0 || productos.length > 0) && optionTipoFactura === 2) {
      const costoOtroNum = Number(subtotolsinIva_otro || 0);
      const ivaOtroNum = Number(iva_otro || 0);
      const totalOtroNum = Number(total_otro || 0);

      // Sumar todo + valores “otros”
      setValue("subtotal_sin_iva", (prodSubTotalSinIva + totalSubtotalSinIva + costoOtroNum).toFixed(2));
      setValue("iva", (prodTotaIVA + totalIVA + ivaOtroNum).toFixed(2));
      setValue("descuento", prodDescuento.toFixed(2)); //
      setValue("total_compra", (prodTotalGeneral + totalGeneral + totalOtroNum).toFixed(2));

    }
  }, [productos, gastos, subtotolsinIva_otro, iva_otro, total_otro, optionTipoFactura])

  return (
    <>
      <Grid container spacing={0} >
        <Grid item container justifyContent={"Center"}>
          <Grid item>
            <Typography variant="h6" style={{ fontWeight: 800, color:'#6c737fb0' }}>{"VALORES DE FACTURA"}</Typography>
            {/* <TabTextLabel text="VALORES DE FACTURA" pl={0} /> */}
          </Grid>
        </Grid>
      </Grid>

      <Grid container spacing={0} item {...gridSizeMdLg12} direction="column">

        {/*  <Grid item>
          <TabTextLabel text="VALORES DE FACTURA" pl={0} />
        </Grid> */}

        <Grid container item direction="column" spacing={3} alignItems="flex-end">
          <Grid item {...gridSizeMdLg6}>
            <CustomTextField
              label="Subtotal sin IVA"
              name="subtotal_sin_iva"
              control={control}
              defaultValue={getValues().subtotal_sin_iva || ""}
              error={!!errors.subtotal_sin_iva}
              helperText={errors.subtotal_sin_iva?.message as string}
              readonly={true}
              disabled={true}

            />
          </Grid>
          {optionTipoFactura !== 1 && (
            <Grid item {...gridSizeMdLg6}>
              <CustomTextField
                label="Descuento"
                name="descuento"
                control={control}
                defaultValue={getValues().descuento || ""}
                error={!!errors.descuento}
                helperText={errors.descuento?.message as string}
                readonly={true}
                disabled={true}
              />
            </Grid>
          )}

          <Grid item {...gridSizeMdLg6}>
            <CustomTextField
              label="IVA"
              name="iva"
              control={control}
              defaultValue={getValues().iva}
              error={!!errors.iva}
              helperText={errors.iva?.message as string}
              disabled={true}
            />
          </Grid>

          <Grid item {...gridSizeMdLg6}>
            <CustomTextField
              label="TOTAL"
              name="total_compra"
              control={control}
              defaultValue={getValues().total_compra || ""}
              error={!!errors.total_compra}
              helperText={errors.total_compra?.message as string}
              disabled={true}
            />
          </Grid>
        </Grid>
      </Grid>
    </>

  )
}